import * as $gzFilters from './filters.service';
import * as editFilters from './filter-dialog/filter-dialog.controller';
import * as saveFilter from './save-dialog/save-dialog.controller';
import gazelleAnalytics from '../../core/analytics/analytics.module';

export default angular.module('gazelle.components.filters', [
  'ngMaterial',
  'angularMoment',
  'pascalprecht.translate',
  'gazelle.components.fields',
  'rhino.core',
  gazelleAnalytics
])
  .service($gzFilters.name, $gzFilters.default)
  .controller(editFilters.name, editFilters.default)
  .controller(saveFilter.name, saveFilter.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/filters/filters.module.js